import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import CreatedDate from './CreatedDate'
import classNames from 'classnames'
import BatchNote from './BatchNote'
import ProductType from './ProductType'
import BatchQuantity from './BatchQuantity'
import RenderTime from '../../helper/RenderTime'
import { Checkbox, Tag, Tooltip } from 'antd'

export function renderBatchTags(tags) {
    const isGiftTag = Array.isArray(tags) && tags.includes('gift')
    const isSampleTag = Array.isArray(tags) && tags.includes('sample')
    const isFbaTag = Array.isArray(tags) && (tags.includes('FBA') || tags.includes('fba'))
    const isFastShipTag = Array.isArray(tags) && tags.includes('fastship')
    const isUIDSAMPLETag = Array.isArray(tags) && tags.includes('UIDSAMPLE')
    const isCutOff = Array.isArray(tags) && tags.includes('cutoff')
    const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
    const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
    const isFastProductionTag = Array.isArray(tags) && tags.includes('fastproduction')
    const isTikTok = Array.isArray(tags) && tags.includes('tiktok')
    const isSLLTag = Array.isArray(tags) && tags.includes('SLL')
    const isComboSock = Array.isArray(tags) && tags.includes('combo_socks')
    const isRnd = Array.isArray(tags) && tags.includes('rnd_test')
    const isForceCmyk = Array.isArray(tags) && tags.includes('force_cmyk')
    const isDlican = Array.isArray(tags) && tags.includes('Dlican')
    const is24h = Array.isArray(tags) && tags.includes('24h')
    const isTestColor = Array.isArray(tags) && tags.includes('test_color')

    return (
        <>
            {
                isGiftTag && <Tag color="#6c757d">Hàng tặng</Tag>
            }

            {
                isSampleTag && <Tag color="#6c757d">Hàng mẫu</Tag>
            }

            {
                isFbaTag && <Tag color="#6c757d">FBA</Tag>
            }

            {
                isFastShipTag && <Tag color="#6c757d">Ship nhanh</Tag>
            }

            {
                isUIDSAMPLETag && <Tag color="#6c757d">UIDSAMPLE</Tag>
            }

            {
                isFastProductionTag && <Tag color="#FFA500">Sản xuất nhanh</Tag>
            }

            {
                isTikTok && <Tag color="#dc3644">TIKTOK</Tag>
            }

            {
                is24h && <Tag color="#dc3644">24h</Tag>
            }

            {
                isCutOff && <Tag color="#FF6600">cutoff</Tag>
            }

            {
                isCutOffNoel && <Tag color="#FF6600">cutoff_noel</Tag>
            }

            {
                isCutOffNewYear && <Tag color="#FF6600">cutoff_new_year</Tag>
            }

            {
                isSLLTag && <Tag color="#fdb813">SLL</Tag>
            }

            {
                isComboSock && <Tag color="#d334ce">Combo socks</Tag>
            }

            {
                isRnd && <Tag color="#6c757d">rnd_test</Tag>
            }

            {
                isForceCmyk && <Tag color="#dc3644">force_cmyk</Tag>
            }

            {
                isDlican && <Tag color="#dc3644">Dlican</Tag>
            }
            {
                isTestColor && <Tag color="#6c757d">test_color</Tag>
            }
        </>
    )
}

// @FAC-24561: nhãn hệ màu ở cột "Người tạo" là 3 nhánh LOẠI TRỪ nhau,
// thứ tự ưu tiên: RGB > Non-CMYK > CMYK. Trả null nghĩa là không hiện nhãn nào.
export function getColorSystemTag(batch = {}) {
    const { tags = [], need_convert_cmyk, merge_file_job } = batch

    if (Array.isArray(tags) && tags.includes('force_rgb')) {
        return { label: 'RGB', color: '#dc3644' }
    }

    if (!need_convert_cmyk) return null

    // merge_file_job có thể là {} (lô chưa gộp lần nào) hoặc job cũ thiếu `meta`
    return merge_file_job?.meta?.non_cmyk === true
        ? { label: 'Non-CMYK', color: '#dc3644' }
        : { label: 'CMYK', color: '#722ed1' }
}

class BatchesRows extends Component {
    _generateLevel = (level) => {
        const color = level === 'highest' ? 'rgb(255 45 0)' : level === 'high' ? '#FFD300' : ''
        return <Tag className={classNames(`tag-${level}`)}
            color={color}>{level !== undefined ? level : 'medium'}</Tag>
    }

    _detectChecked = () => {
        const { item, selectedItems } = this.props
        return selectedItems.includes(item._id)
    }

    _handleChange = () => {
        const { item, updateSelectedOrders } = this.props
        const isChecked = this._detectChecked()

        updateSelectedOrders(item._id, !isChecked)
    }

    render() {
        const { item, onChangeProductType, loadingSend, handleChangeInput, onChangeMaterials } = this.props
        const { status, partner, sewing_partner, merge_file_status, brand, brands, production_times, tags = [], preference = {}, production_meta = {}, metadata = {}, need_convert_cmyk = false, merge_file_job = {}, statistic = {} } = item
        const { materials = [] } = preference
        const { sewing_groups: sewingGroups = [] } = { ...production_meta }
        const arrSewingGroupName = sewingGroups.length > 0 ? sewingGroups.map(i => i.name) : []
        const { type, w, h, is_enable } = { ...metadata.frame }
        const colorSystemTag = getColorSystemTag(item)

        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
            'printing progress-bar-animated progress-bar-striped': status === 'printing',
            'printed': status === 'printed',
            'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
            'transferred': status === 'transferred',
            'confirmed': status === 'confirmed',
            'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
            'sewing': status === 'sewing',
            'completed': status === 'completed' || status === 'done',
            'embroidered': status === 'embroidered',
            'designed': status === 'designed',
        })

        const colorMerge = classNames({
            'pending progress-bar-animated progress-bar-striped': merge_file_status === 'created',
            'printing progress-bar-animated progress-bar-striped': merge_file_status === 'pending',
            'processing progress-bar-animated progress-bar-striped': merge_file_status === 'processing',
            'completed': merge_file_status === 'done',
            'error': merge_file_status === 'error',
            'cancel-ship': merge_file_status === 'retry',
            'convert-cmyk': ['ready', 'converting'].includes(merge_file_status),
        })

        const warningBatch = !!production_times && !!production_times.length && !production_times.every(i => !i || !i.overtime || i.overtime < -1.5)
        const overtimed = !!warningBatch && !!production_times.find(i => !!i && !!i.overtime && i.overtime > 0)
        const almostOvertime = !!warningBatch && !overtimed && !!production_times.find(i => !!i && !!i.overtime && i.overtime >= -1.5 && i.overtime <= 0)
        const wraningStyle = !!warningBatch ? { background: `rgb(${(!!almostOvertime ? "255, 208, 26, 0.3" : (overtimed ? "223, 31, 31, 0.2" : ''))})` } : {}

        return (
            <tr key={item._id} style={wraningStyle}>
                <td className='OrderCheckbox'>
                    <Checkbox disabled={loadingSend} onChange={this._handleChange} checked={this._detectChecked()} />
                </td>
                <td className="nameLo">
                    <Link to={`/batches/${item._id}`}>
                        {item.name}
                    </Link>
                    {
                        this._generateLevel(item.level)
                    }
                    {renderBatchTags(tags)}
                </td>
                <CreatedDate field="created_at" item={item} />
                {/* <CreatedDate field="printed_at" item={item} /> */}
                {/* <CreatedDate field="cut_at" item={item} />
                <CreatedDate field="engraved_at" item={item} />
                <CreatedDate field="improved_at" item={item} /> */}
                <CreatedDate field={!!item.printing_at ? "printing_at" : "printed_at"} item={item} />
                <CreatedDate field="transferred_at" item={item} />
                <CreatedDate field="sewing_at" item={item} />
                <ProductType
                    types={item.product_types}
                    brand={(Array.isArray(brands) && !!brands.length && brands) || brand}
                    onChangeProductType={onChangeProductType}
                    handleChangeInput={handleChangeInput}
                />
                <BatchQuantity item={item} />
                <td className="text-center Status">
                    <div className={`badge ${color || status} badge-pill`}>{status}</div>
                    {
                        // !!statistic.sewing_printed_qr && !!statistic.sewing_not_printed_qr &&
                        <div>
                            <span className='text-success font-weight-bold'>{statistic.sewing_printed_qr}</span> / <span className='text-danger font-weight-bold'>{statistic.sewing_not_printed_qr}</span>
                        </div>
                    }
                </td>
                <td className="Partner d-flex flex-column justify-content-center">
                    {(partner !== undefined && partner !== null) ? <span className='text-center'>{partner.name}</span> : '-'}
                    {
                        materials.map((i, index) => (
                            <div className='d-flex justify-content-center'>
                                <Tag
                                    key={index}
                                    color="#f50"
                                    className='cursor-pointer text-center mr-0 mb-2'
                                    onClick={() => onChangeMaterials(i)}
                                >{i}</Tag>
                            </div>
                        ))
                    }
                    <Tooltip title={`${(!!w || w === 0) ? 'Width' : ''}${((!!w || w === 0) && (!!h || h === 0)) ? ' x ' : ''}${(!!h || h === 0) ? 'Height' : ''}`}>
                        <div className='w-100 text-center font-weight-bold'>
                            {`${(!!w || w === 0) ? w : ''}${((!!w || w === 0) && (!!h || h === 0)) ? ' x ' : ''}${(!!h || h === 0) ? h : ''}`}
                            {type === 'area' && ' (cm)'}
                        </div>
                    </Tooltip>
                </td>
                <td className="Partner">
                    {!!arrSewingGroupName.length && !!sewing_partner ?
                        <>
                            <span>
                                <span className='font-weight-bold'>{sewing_partner.name}</span> - {arrSewingGroupName.join(', ')}
                            </span>
                        </> :
                        ((sewing_partner !== undefined && sewing_partner !== null) ? <span className='font-weight-bold'>{sewing_partner.name}</span> : '-')
                    }
                </td>
                <td className="text-center HumanCreate">
                    {item.user_create}
                    {!!colorSystemTag && (
                        <div><Tag className='mr-0' color={colorSystemTag.color}>{colorSystemTag.label}</Tag></div>
                    )}
                </td>
                <td className="text-center Status">
                    {/* <span className={`badge ${colorMerge} badge-pill`}>{merge_file_status}</span> */}
                    <RenderTime
                        colorMerge={colorMerge}
                        mergeFileStatus={merge_file_status}
                        mergeFileJob={merge_file_job}
                        needConvertCmyk={need_convert_cmyk}
                    />
                    {item.location_name && <div className='font-weight-bold text-danger'>{item.location_name}</div>}
                </td>
                <BatchNote orderId={item._id} note={item.note} />
            </tr>
        )
    }
}

BatchesRows.propTypes = {
    item: PropTypes.object.isRequired,
    onChangeProductType: PropTypes.func
}

export default BatchesRows
